import { render, staticRenderFns } from "./doc5.vue?vue&type=template&id=6e8fec5f"
import script from "./doc5.vue?vue&type=script&lang=js"
export * from "./doc5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports